/* base.js — theme JS.
   Cart system: AJAX add → slide-in drawer, qty/remove via the Section Rendering
   API, focus-trap + scroll-lock + Esc, header badge sync. No framework.
   The /cart page and the drawer share the cart-line view and these handlers. */
(function () {
  'use strict';

  var DRAWER_SECTION = 'cart-drawer';
  var CART_SECTIONS = ['cart-drawer', 'main-cart'];
  var lastFocus = null;
  var busy = false;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function drawer() { return $('[data-cart-drawer]'); }
  function cartError() {
    var d = drawer();
    return (d && d.getAttribute('data-cart-error')) || 'Error';
  }

  /* ---- header badge ---------------------------------------------------- */
  function setCount(n) {
    var el = document.getElementById('cart-count');
    if (!el) return;
    el.textContent = n;
    if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
  }
  function syncCountFromServer() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) setCount(c.item_count); })
      .catch(function () {});
  }

  /* ---- section rendering swap ----------------------------------------- */
  // Replace the live cart containers with freshly-rendered HTML from the API.
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      var html = sections[key];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      // Swap any known cart container the rendered section contains.
      ['[data-cart-inner]', '[data-cart-main]'].forEach(function (target) {
        var fresh = doc.querySelector(target);
        var live = document.querySelector(target);
        if (fresh && live) {
          live.innerHTML = fresh.innerHTML;
          var c = fresh.getAttribute('data-cart-count');
          if (c !== null) setCount(parseInt(c, 10) || 0);
        }
      });
    });
  }

  /* ---- scroll lock ----------------------------------------------------- */
  function lockScroll() {
    var sw = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (sw > 0) document.body.style.paddingRight = sw + 'px';
  }
  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  /* ---- focus trap ------------------------------------------------------ */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
  function trap(e) {
    var d = drawer();
    if (!d || d.hidden || e.key !== 'Tab') return;
    var nodes = Array.prototype.filter.call(d.querySelectorAll(FOCUSABLE), function (n) {
      return n.offsetParent !== null;
    });
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---- open / close ---------------------------------------------------- */
  function openDrawer() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    // next frame → CSS transition
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    lockScroll();
    var panel = $('[data-cart-panel]', d);
    var closeBtn = $('[data-cart-close]', panel);
    (closeBtn || panel).focus();
  }
  function closeDrawer() {
    var d = drawer();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    unlockScroll();
    var done = function () {
      d.hidden = true;
      d.removeEventListener('transitionend', done);
    };
    d.addEventListener('transitionend', done);
    // fallback if no transition fires
    setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 400);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---- cart mutations -------------------------------------------------- */
  function setBusy(state) {
    busy = state;
    var d = drawer();
    if (d) d.classList.toggle('is-busy', state);
    var main = $('[data-cart-main]');
    if (main) main.classList.toggle('is-busy', state);
  }

  function changeLine(key, quantity) {
    if (busy) return;
    setBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: CART_SECTIONS, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.sections) applySections(cart.sections);
        if (cart && typeof cart.item_count === 'number') setCount(cart.item_count);
      })
      .catch(function () { window.alert(cartError()); })
      .finally(function () { setBusy(false); });
  }

  function addToCart(form) {
    if (busy) return;
    setBusy(true);
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    var data = new FormData(form);
    data.append('sections', DRAWER_SECTION);
    data.append('sections_url', window.location.pathname);
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { window.alert(res.body && res.body.description ? res.body.description : cartError()); return; }
        if (res.body && res.body.sections) applySections(res.body.sections);
        else syncCountFromServer();
        openDrawer();
      })
      .catch(function () { syncCountFromServer(); })
      .finally(function () {
        setBusy(false);
        if (btn) btn.classList.remove('is-loading');
      });
  }

  /* ---- delegated events ----------------------------------------------- */
  function lineKey(el) {
    var li = el.closest('[data-line-key]');
    return li ? li.getAttribute('data-line-key') : null;
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); var k = lineKey(rm); if (k) changeLine(k, 0); return; }

    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    if (up || down) {
      e.preventDefault();
      var btn = up || down;
      var key = lineKey(btn);
      var input = $('[data-qty-input]', btn.closest('[data-qty]'));
      if (!key || !input) return;
      var q = (parseInt(input.value, 10) || 0) + (up ? 1 : -1);
      if (q < 0) q = 0;
      changeLine(key, q);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var key = lineKey(input);
    var q = parseInt(input.value, 10);
    if (key == null || isNaN(q) || q < 0) { return; }
    changeLine(key, q);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); return; }
    trap(e);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('form[action*="/cart/add"]')) {
      e.preventDefault();
      addToCart(form);
    }
  });

  /* ---- boot ------------------------------------------------------------ */
  if (document.readyState !== 'loading') syncCountFromServer();
  else document.addEventListener('DOMContentLoaded', syncCountFromServer);
})();
